import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';

// This Class Component is designed to isolate the buggy ReactApexChart instance.
class ApexChartWrapper extends Component {

    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    // 💡 This is where the old library crash happens (unmount phase)
    // By using a class component, we give it a clear, separate destruction lifecycle.

    // Note: We don't add lifecycle methods here, but the simple class structure 
    // is often enough to create a stable boundary for the library.

    static getDerivedStateFromError(error) {
        console.log("ApexChartWrapper: Caught internal unmount crash:", error);
        // Update state to render the fallback (null) and suppress the crash
        return { hasError: true };
    }

  componentWillUnmount() {
    // If the crash happens BEFORE this log appears, the error is irrecoverable in React 16.
    console.log("ApexChartWrapper: Running final cleanup.");
    // We cannot reliably access the underlying chart instance here without knowing its API,
    // so we rely on React's destruction (triggered by the 'key' prop) being clean.
  }

  componentDidCatch(error, errorInfo) {
    console.log("ApexChart Internal Cleanup Failure Details:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // FIX APPLIED: When the crash occurs during unmount, we return empty React.Frament.
      // This tells React: "This component failed; safely remove it now and continue."
      return (<React.Fragment></React.Fragment>);
    }

    const { options, series, type, height, stroke, chartKey } = this.props;
    if (!options || !series) {
      console.warn("ApexChartWrapper: Chart options or series data is missing.");
      return (<React.Fragment></React.Fragment>);
    }

    return (
      <ReactApexChart
        options={options}
        chartKey={chartKey}
        series={series}
        type={type}
        height={height}
        stroke={stroke}
      />
    );
  }
}

export default ApexChartWrapper;